import {CircularProgress} from '@mui/material'
import {useState} from 'react'

interface LazyImageProps {
  src: string | null | undefined
  alt?: string
  className?: string
  style?: React.CSSProperties
  width?: number | string
  height?: number | string
  onClick?: (e: React.MouseEvent<HTMLImageElement>) => void
  fallback?: React.ReactNode
}

const LazyImage = ({src, alt = '', className, style, width, height, onClick, fallback}: LazyImageProps) => {
  const [status, setStatus] = useState<'loading' | 'loaded' | 'error'>('loading')

  const showFallback = !src || status === 'error'

  if (showFallback) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: width ?? '100%',
          height: height ?? '100%',
          minHeight: 60,
        }}
        onClick={onClick as any}
      >
        {fallback ?? <span style={{color: '#9e9e9e', fontSize: 12}}>이미지 없음</span>}
      </div>
    )
  }

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: width ?? '100%',
        height: height ?? '100%',
        minHeight: 60,
      }}
    >
      {status === 'loading' && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress size={28} thickness={3} />
        </div>
      )}
      {/* 로드 전까지 hidden으로 유지해 브라우저 broken 아이콘 노출 방지 */}
      <img
        src={src}
        alt={alt}
        className={className}
        style={{
          ...style,
          opacity: status === 'loaded' ? 1 : 0,
          transition: 'opacity 0.35s ease',
          visibility: status === 'loaded' ? 'visible' : 'hidden',
          position: status === 'loaded' ? 'static' : 'absolute',
        }}
        width={width}
        height={height}
        onClick={onClick}
        onLoad={() => setStatus('loaded')}
        onError={() => setStatus('error')}
      />
    </div>
  )
}

export default LazyImage
